import firebase from 'firebase/app';
import 'firebase/firestore';


firebase.initializeApp ({
    apiKey: "AIzaSyBsCRr7I7bdeUSqC54USqAZprIWL0tdyz8",
    authDomain: "proximy-site.firebaseapp.com",
    projectId: "proximy-site",
    storageBucket: "proximy-site.appspot.com",
    messagingSenderId: "1049815396778",
    appId: "1:1049815396778:web:d34036aee596fa06b8fbd3",
    measurementId: "G-SZSX3L2LG2"
  });

  export default firebase;